import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { AnimateLoading, Gdpr } from "../../_partials";
import { Aside } from "./aside/Aside";
import { Auth } from "./header/Auth";
import { SearchSite } from "./header/SearchSite";
import { ThemeSwitch } from "./header/ThemeSwitch";

export function Layout() {
    const [offCanvas, setOffCanvas] = useState(false);
    const toggleOffCanvas = () => {
        if (!offCanvas) {
            setOffCanvas(true);
            document.body.classList.add('offcanvas');
        } else {
            setOffCanvas(false);
            document.body.classList.remove('offcanvas');
        }
    };
    const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
    useEffect(() => {
        var scrollToTopBtn = document.querySelector(".scroll-to-top");
        document.addEventListener("scroll", () => {
            var scrollableHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
            var MIN_SCROLL_RATIO = 0.2; // 20% from top
            if ((document.documentElement.scrollTop / scrollableHeight) > MIN_SCROLL_RATIO) scrollToTopBtn.style.display = "flex";
            else scrollToTopBtn.style.display = "none";
        });
    });
    return (<>
        <AnimateLoading />
        <div id="martin-page">
            <div className="container-wrap">
                <span onClick={() => toggleOffCanvas()} className={"js-martin-nav-toggle martin-nav-toggle" + (offCanvas ? " active" : "")}><i></i></span>
                <Aside />
                <div id="martin-main">
                    <div className="martin-auth">
                        <SearchSite />
                        <ThemeSwitch />
                        <Auth />
                    </div>
                    <Outlet />
                    <div className="scroll-to-top" onClick={() => scrollToTop()}>
                        <i className="icon-arrow-up-thick"></i>
                    </div>
                    <Gdpr />
                </div>
            </div>
        </div>
    </>);
}
